import { NgModule, Injectable } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';
import { SourceCodeExcludesComponent } from './pages/dashboard/source-code-excludes.component';

@Injectable({ providedIn: 'root' })
export class SourceCodeExcludesAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        if (
            this.activeFeatureService.isFeatureActive('admin_source_code_excludes') ||
            this.activeFeatureService.isFeatureActive('admin_accessibility')
        ) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.dashboard', params) as unknown as Promise<void>;
        });
    }
}

const sourceCodeExcludesStates = [
    {
        name: 'base.customer.admin.source_code_excludes',
        url: '/accessibility/source-code-excludes',
        abstract: true,
        data: {
            title: 'Acquia Web Governance - Source Code Excludes',
            htmlContent: '<div ui-view></div>',
        },
        resolve: [
            {
                token: 'sourceCodeExcludesAccess',
                deps: [SourceCodeExcludesAccessGuard, Transition],
                resolveFn: (guard: SourceCodeExcludesAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
    },
    {
        name: 'base.customer.admin.source_code_excludes.index',
        url: '?page_size&page',
        dynamic: true,
        views: {
            'content@base.customer.admin': {
                component: SourceCodeExcludesComponent,
            },
        },
        data: {
            htmlContent: '<div ui-view></div>',
        },
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states: sourceCodeExcludesStates })],
    exports: [UIRouterModule],
})
export class SourceCodeExcludesRoutingModule { }
